export default __webpack_public_path__ + "static/media/zoomsquare.edd7a6cc.svg";